/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MeliEnqueuedPublicationDraftResponse } from '../models/MeliEnqueuedPublicationDraftResponse';
import type { MeliPersistedPublicationActionBody } from '../models/MeliPersistedPublicationActionBody';
import type { MeliPublicationDraftPersistResponse } from '../models/MeliPublicationDraftPersistResponse';
import type { MeliPublicationDraftResponse } from '../models/MeliPublicationDraftResponse';
import type { MeliPublicationPublishResponse } from '../models/MeliPublicationPublishResponse';
import type { PrepareMeliPublicationDraftParams } from '../models/PrepareMeliPublicationDraftParams';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IntegrationsMeliPublishingService {
    /**
     * Prepares a MercadoLibre publication draft and validation result for a property.
     * @param requestBody
     * @returns MeliPublicationDraftResponse Ok
     * @throws ApiError
     */
    public static preparePublicationDraft(
        requestBody: PrepareMeliPublicationDraftParams,
    ): CancelablePromise<MeliPublicationDraftResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/meli/publishing/draft',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Prepares a MercadoLibre publication draft and persists its durable publication record.
     * @param requestBody
     * @returns MeliPublicationDraftPersistResponse Ok
     * @throws ApiError
     */
    public static prepareAndPersistPublicationDraft(
        requestBody: PrepareMeliPublicationDraftParams,
    ): CancelablePromise<MeliPublicationDraftPersistResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/meli/publishing/draft/persist',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Publishes a MercadoLibre draft immediately by creating or updating the remote item.
     * @param requestBody
     * @returns MeliPublicationPublishResponse Ok
     * @throws ApiError
     */
    public static publish(
        requestBody: PrepareMeliPublicationDraftParams,
    ): CancelablePromise<MeliPublicationPublishResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/meli/publishing/publish',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Persists a MercadoLibre draft and enqueues async publish execution.
     * @param requestBody
     * @returns MeliEnqueuedPublicationDraftResponse Ok
     * @throws ApiError
     */
    public static enqueuePublish(
        requestBody: PrepareMeliPublicationDraftParams,
    ): CancelablePromise<MeliEnqueuedPublicationDraftResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/meli/publishing/publish/enqueue',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Publishes a previously persisted MercadoLibre publication configuration.
     * @param requestBody
     * @returns MeliPublicationPublishResponse Ok
     * @throws ApiError
     */
    public static publishPersisted(
        requestBody: MeliPersistedPublicationActionBody,
    ): CancelablePromise<MeliPublicationPublishResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/integrations/meli/publishing/publish/persisted',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
